import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Phone, Mail, Clock } from 'lucide-react';
import { contactInfo, footerLinks } from '../data/mock';

const Footer = () => {
  const navigate = useNavigate();

  const handleFooterNav = (to) => {
    if (to.startsWith('/#')) {
      const id = to.substring(2);
      navigate('/');
      setTimeout(() => {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: 'smooth' });
      }, 100);
    } else {
      navigate(to);
      window.scrollTo(0, 0);
    }
  };

  return (
    <footer className="bg-slate-900 text-white">
      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 lg:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
          {/* Company Info */}
          <div className="space-y-4">
            <a href="#" className="flex items-center">
              <img
                src="/images/logo-lynko-footer.png"
                alt="LYNKO - Connecter, Installer, Accompagner"
                className="h-11 w-auto object-contain"
              />
            </a>
            <p className="text-xs text-gray-500 uppercase tracking-widest">
              Connecter · Installer · Accompagner
            </p>
            <p className="text-gray-400 text-sm leading-relaxed">
              Votre partenaire de confiance pour l'installation et le support informatique professionnel.
            </p>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-bold text-lg mb-4">Services</h4>
            <ul className="space-y-2">
              {footerLinks.services.map((link, index) => (
                <li key={index}>
                  <button
                    type="button"
                    onClick={() => handleFooterNav(link.to)}
                    className="text-gray-400 hover:text-white transition-colors duration-200 text-sm text-left"
                  >
                    {link.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-bold text-lg mb-4">Liens Rapides</h4>
            <ul className="space-y-2">
              {footerLinks.quickLinks.map((link, index) => (
                <li key={index}>
                  <button
                    type="button"
                    onClick={() => handleFooterNav(link.to)}
                    className="text-gray-400 hover:text-white transition-colors duration-200 text-sm text-left"
                  >
                    {link.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-bold text-lg mb-4">Contact</h4>
            <ul className="space-y-3">
              <li className="flex items-center gap-3 text-gray-400 text-sm">
                <Phone className="w-4 h-4 text-blue-400" />
                <span>{contactInfo.phone}</span>
              </li>
              <li className="flex items-center gap-3 text-gray-400 text-sm">
                <Mail className="w-4 h-4 text-blue-400" />
                <span>{contactInfo.email}</span>
              </li>
              <li className="flex items-start gap-3 text-gray-400 text-sm">
                <Clock className="w-4 h-4 text-blue-400 mt-0.5" />
                <div>
                  <p>Lun-Ven: 9h-18h</p>
                  <p>Sam: 9h-12h</p>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Footer */}
      <div className="border-t border-slate-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-400 text-sm">
              © 2026 LYNKO. Tous droits réservés.
            </p>
            <div className="flex flex-wrap justify-center gap-6 text-sm">
              <button type="button" onClick={() => handleFooterNav('/mentions-legales')} className="text-gray-400 hover:text-white transition-colors duration-200">
                Mentions légales
              </button>
              <button type="button" onClick={() => handleFooterNav('/politique-de-confidentialite')} className="text-gray-400 hover:text-white transition-colors duration-200">
                Politique de confidentialité
              </button>
              <button type="button" onClick={() => handleFooterNav('/cgv')} className="text-gray-400 hover:text-white transition-colors duration-200">
                CGV
              </button>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
